// @owners { team: patients }
import { SPACING } from '@alto/design-library-tokens';
import { Body, LgPadding } from '@alto/design-system';
import React from 'react';
import { getCompanyName } from '~shared/config/getCompanyName';
import { CONTACT_US_ORIGIN } from '~shared/constants';
import { ContactProgynyActionSheet } from './ContactProgynyActionSheet';

export const DosageChangeContactProgynyActionSheet = () => {
  return (
    <ContactProgynyActionSheet
      title={`Get in touch with ${getCompanyName()} to complete your order`}
      origin={CONTACT_US_ORIGIN.DosageChangeContactUsActionSheet}
    >
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        <Body>
          Send us a message with the medication name and updated dosage, or give us a call if the timing is urgent.
          We'll contact your provider for an updated prescription and notify you as soon as it's ready to schedule.
        </Body>
      </LgPadding>
    </ContactProgynyActionSheet>
  );
};
